import { ProductForm } from "@features/products/components/ProductForm";
import { toast } from "sonner";
import { useProducts } from '@features/products/hooks/useProducts';
import { useNavigate } from "react-router-dom";
import HeadLayout from "@shared/layouts/HeadLayout";
import { useTranslation } from "react-i18next";

const CreateProduct = () => {
  const { createProduct, createProductLoading } = useProducts();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleCreateProduct = (values) => {
    createProduct(values, {
      onSuccess: () => {
        console.log(values);
        toast.success(`Product created ${values.name}`);
        navigate("/products");
      },
      onError: (error) => {
        toast.error(error.response.data.message);
      },
    });
  };

  return (
    <>
      <HeadLayout title={t("products.createProduct")} />
      <div className="bg-background p-4 rounded-xl">
        <ProductForm
          action="create"
          onSubmit={handleCreateProduct}
          isloading={createProductLoading}
        />
      </div>
    </>
  );
};

export default CreateProduct;
